import { interpolate } from '../../../global';
import { ILanguageResources, ITranslationModule } from '../../../interfaces';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scriptsV6.v6config.v6-quote-item.UpdateV6DefaultsModal.';
  public static readonly bodyText = `${Id.prefix}bodyText`;
}

export class LangV6UpdateDefaultsModal {
  private constructor() {}

  public static bodyText(params: {
    attributeTypeDisplayLabel: string;
    attributeDisplayLabel: string;
    attributeDisplayValue: string;
  }): string {
    return interpolate(Id.bodyText, params);
  }
}

export class V6UpdateDefaultsModalModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.bodyText,
      `You have modified an item that is a **{{attributeTypeDisplayLabel}}**, would you like to make this a Default attribute for any subsequent {{glossary 'frame:plural'}} added to the {{glossary 'quote'}}?

+ **{{attributeDisplayLabel}}**
++ **{{attributeDisplayValue}}**`,
      'Body text for update V6 defaults modal, with attribute and value interpolation'
    );
  }
}
